import React from 'react';
import site from '../content/siteContent';

export default function AboutSection() {
  const machines = [
    {
      name: 'Panel Saw',
      image: '/images/processed/machinery/machine-panelsaw--1200x900.jpg',
      description:
        'High-precision panel saw for accurate cutting and sizing of wood panels and boards.',
    },
    {
      name: 'Edge Bander',
      image: '/images/processed/machinery/machine-edgebander--1200x900.jpg',
      description: 'Professional edge banding machine for seamless edge finishing.',
    },
    {
      name: 'Cold Press',
      image: '/images/processed/machinery/machine-panelsaw-8468-1200x900.jpg', // Using panel saw image temporarily
      description: 'Industrial cold press machine for lamination and veneering.',
    },
  ];

  return (
    <div className="space-y-16">
      {/* About Section */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center">
        <div>
          <h2 className="text-2xl font-semibold mb-3">About Us</h2>
          <div className="text-sm uppercase tracking-wide text-muted">{site.tagline}</div>
          <p className="mt-4 text-neutralText text-content leading-relaxed">{site.description}</p>
          <div className="mt-6">
            <a
              href="/about"
              className="btn btn-wood hover:scale-105 transform transition-transform duration-300"
            >
              Learn More
            </a>
          </div>
        </div>
        <div>
          <div className="card overflow-hidden">
            <img
              src="/images/processed/misc/GDM Interior Industries Vallioor Gallery 01-800x600.jpg"
              alt="About"
              loading="lazy"
              className="w-full h-64 object-cover"
            />
          </div>
        </div>
      </div>

      {/* Machinery Section */}
      <div>
        <h2 className="text-2xl font-semibold mb-8 text-center">Our Advanced Machinery</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {machines.map((machine, index) => (
            <div key={machine.name} className="card overflow-hidden group">
              <div className="relative">
                <img
                  src={machine.image}
                  srcSet={`${machine.image.replace('1200x900', '400x300')} 400w,
                          ${machine.image.replace('1200x900', '800x600')} 800w,
                          ${machine.image} 1200w`}
                  sizes="(max-width: 768px) 100vw, 33vw"
                  alt={machine.name}
                  loading="lazy"
                  className="w-full aspect-4/3 object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black bg-opacity-40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                  <div className="text-white text-center p-4">
                    <h3 className="text-xl font-semibold mb-2">{machine.name}</h3>
                    <p className="text-sm">{machine.description}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
